









































// Libraries
import { Component, Prop } from 'vue-property-decorator'
import { mapState } from 'vuex'

// Mixins
import MatchMixin from '@/mixins/match'

import { Penalty } from 'match-central-shared/src/types/penalties'
import { PenaltyDuration } from 'match-central-shared/src/types/match-config'

// Sub views

@Component({
  components: {
    //
  },

  computed: {
    ...mapState(['onLine']),
    ...mapState('match', ['match']),
  },
})
export default class PenaltyDurationView extends MatchMixin {
  @Prop() readonly config!: PenaltyDuration

  inProduction = process.env.NODE_ENV === 'production'

  get homeTeamActivePenalties(): Penalty[] {
    if (!this.homeTeam) {
      return []
    }
    return this.homeTeam.penalties.filter((p) => p.duration === this.config.value)
  }

  get visitorTeamActivePenalties(): Penalty[] {
    if (!this.visitorTeam) {
      return []
    }
    return this.visitorTeam.penalties.filter((p) => p.duration === this.config.value)
  }

  get homeTeamNumberOfAllPenalties(): number {
    if (!this.match) {
      return 0
    }

    if (!this.match.hPenalties) {
      return 0
    }

    return this.match.hPenalties.filter((p) => p.duration === this.config.value).length
  }

  get visitorTeamNumberOfAllPenalties(): number {
    if (!this.match) {
      return 0
    }

    if (!this.match.vPenalties) {
      return 0
    }

    return this.match.vPenalties.filter((p) => p.duration === this.config.value).length
  }
}
